"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSCLanguageCookieHeader = exports.hasLocale = void 0;
const constants_1 = require("../lib/constants");
const locales_1 = require("../lib/locales");
const cookie_1 = require("cookie");
function hasLocale(req) {
    const url = new URL(req.url ?? "", "https://www.snapchat.com");
    const localeFromQueryParam = url.searchParams.get("locale");
    const pathArr = url.pathname.split("/").filter(Boolean);
    const localeFromURLPath = constants_1.ALL_LOCALES.includes(pathArr[0]) ? pathArr[0] : undefined;
    const localeEnumFromCookies = (0, locales_1.getLocaleFromCookie)(req.headers.cookie ?? "");
    const localeFromCookies = localeEnumFromCookies ? (0, locales_1.formatLocale)(localeEnumFromCookies) : undefined;
    return Boolean(localeFromQueryParam || localeFromURLPath || localeFromCookies);
}
exports.hasLocale = hasLocale;
function setSCLanguageCookieHeader(req, res) {
    if (hasLocale(req)) {
        // Only run for Requests that don't specify a locale (in URL or sc-language cookie)
        return;
    }
    const acceptLangHeader = req.headers["accept-language"] ?? "";
    const acceptLangLocale = (0, locales_1.getLocaleFromAcceptLang)(acceptLangHeader) ?? constants_1.Locale.enUS;
    const expires = new Date();
    expires.setFullYear(expires.getFullYear() + 1);
    const serializedCookie = (0, cookie_1.serialize)(locales_1.SC_COOKIE_KEY_LOCALE, acceptLangLocale, {
        domain: ".snapchat.com",
        expires,
        path: "/",
        secure: true,
        httpOnly: false,
    });
    res.setHeader("Set-Cookie", serializedCookie);
}
exports.setSCLanguageCookieHeader = setSCLanguageCookieHeader;
//# sourceMappingURL=responses.js.map